export default "__VITE_ASSET___D6FzgGL__"